import React from 'react';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';

import ProductService from '../../../services/productService';
import ImportDataForm from 'components/ImportData';
import { defaultImportFields } from 'components/ImportData/data/fields';

import { POSSIBLE_FILTERS_ENTITIES } from '../../../../../../hooks/useMemorizeInputsFilters';

/**
 * Componente ImportProductsModal para gerenciar a importação de dados de produtos.
 *
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.isOpen - Controla se o modal está visível
 * @param {Function} props.setIsOpen - Função para alternar a visibilidade do modal
 * @param {string|number} props.recordTypeId - ID do tipo de registro para os produtos estão sendo importados
 *
 * @returns {JSX.Element} A interface do modal de importação de contas
 */

const ImportProductsModal = ({ isOpen, setIsOpen, recordTypeId }) => {
  const { getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.PRODUCT,
    recordTypeId
  );

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      recordTypeId={recordTypeId}
      importService={ProductService.importProducts}
      defaultFields={defaultImportFields.CRM_PRODUCTS}
      filterEntity={POSSIBLE_FILTERS_ENTITIES.CRM_PRODUCT_IMPORT}
      getCustomFields={getCustomFields}
    />
  );
};

export default ImportProductsModal;
